import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PermissaoUsuario } from 'src/app/models/permissao-usuario';
import { map } from 'rxjs/operators';
import { Unidade } from 'src/app/models/Unidade';
import { stringify } from 'querystring';
import { UsuarioUnidade } from 'src/app/models/usuario-unidade';
import { Consulta } from 'src/app/models/consulta';

@Injectable({
  providedIn: 'root'
})
export class UnidadeService {

  constructor(private httpClient: HttpClient) { }

  getListaPermissaoUsuario() {
    return this.httpClient.get
      <PermissaoUsuario[]>
      (environment.wsUrl + 'usuario/listaPermissaoUsuario').toPromise();
  }

  getTabelaPrecoConsulta() {
    return this.httpClient.get<{
      id: number
      idUnidadeCriadora: number,
      nome: string
    }[]>(environment.wsUrl + 'tabelaPreco/getTabelaPrecoNome').toPromise();
  }

  getTabelaPrecoConsultaUnidadeCliente(idUnidadeCliente: Number) {
    return this.httpClient.get<{
      id: number
      idUnidadeCriadora: number,
      nome: string
    }[]>(environment.wsUrl + 'tabelaPreco/getTabelaPrecoNome/'+idUnidadeCliente).toPromise();
  }

  getListaTipoUnidade() {
    return this.httpClient.get<{
      desabilitado: boolean,
      descricao: string,
      id: number,
      nivel: number,
      nome: string
    }[]>(environment.wsUrl + 'unidade/listaTipoUnidade').toPromise();
  }

  //só vem o nome neste metodo, nao sei se faz o mesmo q o 'unidade/listaTipoUnidade' porem com menos info
  getListaTipoUnidadeCliente() {
    return this.httpClient.get<{
      nome: string,
    }[]>(environment.wsUrl + 'unidade/listaTipos').toPromise();
  }

  getListaUnidadeNomeFantasia() {
    return this.httpClient.get<{
      id: number,
      documento: string,
      nomeFantasia: string,
      razaoSocial: string,
      status: boolean,
      motivoBloqueio: string,
    }[]>(environment.wsUrl + 'unidade/listaUnidadeNomeFantasia').toPromise();
  }

  getListaUnidadeNomeFilter(filter, ignore = []) {
    return this.httpClient.post<{
      total: number,
      lista: {
        descricao: string,
        documento: string,
        exibirdocumentoconsultas: boolean,
        idtipounidade: number,
        idunidade: number,
        nome: string,
        nomefantasia: string,
        razaosocial: string,
        status: boolean,
        motivobloqueio: string,
      }[]
    }>(environment.wsUrl + 'unidade/listaUnidadeNomeFantasia', filter, { params: { ignore: ignore } }).pipe(
    ).toPromise();
  }

  getListaTipoCliente() {
    return this.httpClient.get(environment.wsUrl + 'unidade/listaTipoCliente').toPromise();
  }

  getTabelaPrecoTipoLaudo() {
    return this.httpClient.get<{
      descricao: string
      id: string,
      nome: string
    }[]>(environment.wsUrl + 'laudo/getListaTabelaPrecoTipoLaudoNome').toPromise();
  }

  verificaLogin(data, ignore = ['loading']) {
    return this.httpClient.post(environment.wsUrl + 'cliente/verificaLogin', data, {
      headers: {},
    }).toPromise();
  }

  criarUnidade(data, justificativa, ignore = []) { //bloquear
    return this.httpClient.post<null>(environment.wsUrl + 'unidade/criarUnidade', data,
      {
        headers: { ignore: ignore, justificativa: justificativa },
      }).toPromise();
  }

  getUnidade(uuid, ignore = [], ignorePai = false) {
    return this.httpClient.get<{ logo: string, unidade: Unidade }>(environment.wsUrl + 'unidade/getUnidade/' + uuid, {
      headers: {
        ignore: ignore
      },
      params: new HttpParams().set('ignorePai', ignorePai)
    }).pipe(
      map(r => ({
        logo: r.logo, unidade: new Unidade(r.unidade)
      }))
    ).toPromise();
  }

  atualizarStatusUnidade(unidade, justificativa, ignore = []) { //bloquear
    return this.httpClient.post(environment.wsUrl + 'unidade/atualizarStatusUnidade', unidade, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }

  atualizarUnidade(unidade, justificativa, ignore = []) { //bloquear
    return this.httpClient.post(environment.wsUrl + 'unidade/atualizarUnidade', unidade, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }

  removerUnidade(unidade, justificativa, ignore = []) { //bloquear
    return this.httpClient.post(environment.wsUrl + 'unidade/removerUnidade', unidade, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }


  adicionarTipoUnidade(unidade, justificativa, ignore = []) { 
    return this.httpClient.post(environment.wsUrl + 'unidade/criarTipoUnidade', unidade, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }

  editarTipoUnidade(unidade, justificativa, ignore = []) {
    return this.httpClient.post(environment.wsUrl + 'unidade/atualizarTipoUnidade', unidade, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }

  buscarUnidade(id) {
    return this.httpClient.get(environment.wsUrl + 'unidade/getUnidade/' + id);
  }

  // Ponto de atendimento

  getPontosAtendimento(id) {
    return this.httpClient.get(environment.wsUrl + 'unidade/getPontosAtendimento/' + id);
  }

  addPontosAtendimento(params) { 
    return this.httpClient.post(environment.wsUrl + 'unidade/criarPontoAtendimentoUnico', params).toPromise();
  }

  delPontosAtendimento(params, justificativa: string, ignore = []) {
    return this.httpClient.post(environment.wsUrl + 'unidade/removePontoAtendimentoUnico', params, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }

  getUnidadesAtendidas(id) {
    return this.httpClient.get(environment.wsUrl + 'unidade/getListaUnidadesAtendidas/' + id);
  }

  addUnidadeAtendida(params) {
    return this.httpClient.post(environment.wsUrl + 'unidade/criarPontoAtendimentoUnico', params).toPromise();
  }

  delUnidadeAtendida(params, justificativa: string, ignore = []) {
    return this.httpClient.post(environment.wsUrl + 'unidade/removePontoAtendimentoUnico', params, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }

  getDadosCnpjRg(cnpj: string) {
    cnpj = cnpj.replace(/\D/g,'');
    return this.httpClient.get(environment.wsUrl + 'unidade/consultarCnpjRg/'+cnpj).toPromise();
  }

}
